<template>
    <chart-card>
        <template slot="header">
            <h4 class="card-title">Vendas por Faixa Etária</h4>
            <p class="card-category">Vendas do periodo segmentadas por faixa etária</p>
        </template>
        <template slot="footer">
            <hr>
            <div class="stats">
                <i class="fa fa-clock-o"></i> Ultima atualização: {{lastUpdatedFormated}}
            </div>
        </template>
        <apexchart type="bar" ref="chart" height="350" :options="chartOptions" :series="series"></apexchart>
    </chart-card>
</template>

<script>
    import ChartCard from "@/components/ChartCard";
    import moment from "moment";
    export default {
        name: "BarsByAge",
        components: {ChartCard},
        props: ['chartData','lastUpdated'],
        computed:{
            lastUpdatedFormated (){
                return moment(this.lastUpdated, 'YYYY-MM-DD').format('DD/MM/YYYY [às] HH:mm:ss')
            },
            series (){
                var d = [{
                    name: 'Casos',
                    data: []
                }];
                this.chartData.forEach(function (data) {
                    d[0].data.push(data.cases)
                });
                return d;
            },
            chartOptions(){
                var d = [];
                this.chartData.forEach(function (data) {
                    d.push(data.range)
                });
                return {
                    chart: {
                        type: 'bar',
                        height: 350
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            columnWidth: '55%',
                        },
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                    },
                    xaxis: {
                        categories: d,
                    },
                    fill: {
                        opacity: 1
                    },
                    tooltip: {
                        y: {
                            formatter: function (val) {
                                return val
                            }
                        }
                    }
                };
            }
        },
        data: function () {
            return {
            }
        }
    }
</script>

<style scoped>

</style>